<template>
  <v-row no-gutters>
    <feature-card-basic
      ref="feature-card"
      :layer="layer"
      :disabled-attributes="disabledAttributes"
      @update:feature="onFeature"
    >
      <template #top="{ isEditingOn }" v-if="visible">
        <masterplan-streets-widget
          :fid="+currentFeatureId"
          :lid="+layer.id"
          :street-properties.sync="feature.properties"
          :disabled="isEditingOn"
          @refreshFormData="refreshFormData"
        />
      </template>
    </feature-card-basic>
  </v-row>
</template>
<script>
import { get } from 'vuex-pathify';

import FeatureCardBasic from '@/components/FeatureCardBasic';
import MasterplanStreetsWidget from '@/components/MasterplanStreetsWidget';

export default {
  name: 'FeatureCardMasterplanStreets',
  components: { FeatureCardBasic, MasterplanStreetsWidget },
  props: {
    layer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    masterplanStreetsDataSourceMapping: get('admin/modulesMapping@masterplan_2_streets@masterplan_street_datasource'),
    disabledAttributes() {
      return Object.keys(this.masterplanStreetsDataSourceMapping?.settings)
        .filter(key => key.includes('attribute'))
        .reduce((total, current) => {
          total.push(this.masterplanStreetsDataSourceMapping.settings[current]);
          return total;
        }, []);
    },
    isAdminEnabled: get('admin/settingsValues@masterplan_2_streets_module_enabled'),
    isSuperAdminEnabled: get('admin/additionalModules@MASTERPLAN_2_STREETS.enabled'),
    permission: get('users/toolsPermissions@MASTERPLAN_2_STREETS.main_value'),
    currentFeatureId() {
      return this.$route.params.fid;
    },
    isNew() {
      return this.currentFeatureId === 'new';
    },
    visible() {
      return this.isSuperAdminEnabled && this.isAdminEnabled && !this.isNew && this.permission;
    },
  },
  data: () => ({
    feature: undefined,
  }),
  methods: {
    onFeature(feature) {
      this.feature = { ...feature };
    },
    refreshFormData() {
      this.$refs['feature-card']?.refreshFormData();
    },
  },
};
</script>
